;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .controller('JobOutcomePolicyCtrl', JobOutcomePolicyCtrl)

  function JobOutcomePolicyCtrl(
    $scope,
    $location,
    $routeParams,
    $q,
    $translate,
    UserService,
    ServiceUtils,
    JobOutcomePolicyService,
    INTEGRATION_TYPE,
    INTEGRATION_CONNECTION_STATUS
  ) {
    'ngInject'

    var jobOutcomePolicy = $routeParams.jobOutcomePolicy

    angular.extend($scope, {
      testing: false,
      model: {
        credentials: undefined,
        name: '',
        username: '',
        password: '',
        host: ''
      },
      credentialsId: '',
      credentialsPromise: undefined,
      loadPromise: undefined,
      renamePromise: undefined,
      connectionStatus: INTEGRATION_CONNECTION_STATUS.STANDBY,
      select: {
        credentials: []
      },
      errorCode: undefined,
      errorMsgs: []
    })

    angular.extend($scope, {
      testConnection: testConnection,
      resetConnection: resetConnection,
      validForm: validForm,
      hasUsernameField: hasUsernameField,
      getPasswordFieldName: getPasswordFieldName,
      editName: editName,
      getIntegrationLogo: getIntegrationLogo,
      getLogoClass: getLogoClass,
      save: save,
      cancelEdit: cancelEdit
    })

    function init() {
      _getJobOutcomePolicyCredentials()
    }

    function _getJobOutcomePolicyCredentials() {
      $scope.credentialsPromise = JobOutcomePolicyService.getCredentialsList(
        jobOutcomePolicy
      ).then(function (response) {
        $scope.select.credentials = response.data.credentialsList
        if ($scope.select.credentials) {
          $scope.model.credentials = $scope.select.credentials[0]
          _updateCredentialsFields($scope.model.credentials)
        }
      })
    }

    function _clearOnSuccess(promise) {
      $scope.testing = false
      promise.resolve()
    }

    function _clearOnFailure(promise) {
      $scope.testing = false
      promise.reject()
    }

    function _updateCurrentCredentialsName() {
      $scope.model.credentials.name = $scope.model.name

      var creds = _.find($scope.select.credentials, function (creds) {
        return $scope.credentialsId === creds.id
      })
      creds.name = $scope.model.credentials.name
    }

    function testConnection() {
      $scope.testing = true
      var dataLoadingPromise = $q.defer()

      $scope.loadPromise = dataLoadingPromise.promise

      _testJobOutcomePolicyConnection(dataLoadingPromise).then(
        function () {
          $scope.connectionStatus = INTEGRATION_CONNECTION_STATUS.VALID
          _clearOnSuccess(dataLoadingPromise)
        },
        function (data) {
          $scope.connectionStatus = INTEGRATION_CONNECTION_STATUS.INVALID
          _clearOnFailure(dataLoadingPromise)

          $scope.errorCode = data.error_code
          $scope.errorMsgs = data.jop_errors
        }
      )
    }

    function _testJobOutcomePolicyConnection(promise) {
      switch (jobOutcomePolicy.toUpperCase()) {
        case INTEGRATION_TYPE.JENKINS:
          return _testJenkinsConnection()
        default:
          $scope.errorMsgs = [
            $translate.instant(
              'detail_integrationsSettings_jenkinsTestUnsupported'
            )
          ]
          return promise.reject()
      }
    }

    function _testJenkinsConnection() {
      var form = JobOutcomePolicyService.buildJenkinsIntegrationTest(
        $scope.model
      )
      return JobOutcomePolicyService.testJenkinsJobOutcomePolicy(form)
    }

    function editName() {
      JobOutcomePolicyService.openCredentialsRenameModal(
        $scope.model.name
      ).then(function (result) {
        $scope.model.name = result.name
        $scope.renamePromise = JobOutcomePolicyService.renameCredentialSet(
          jobOutcomePolicy,
          result,
          $scope.credentialsId
        )
          .then(function () {
            _updateCurrentCredentialsName()
          })
          .catch(ServiceUtils.handleError)
      })
    }

    function resetConnection() {
      $scope.connectionStatus = INTEGRATION_CONNECTION_STATUS.STANDBY
      $scope.errorCode = undefined
      $scope.errorMsgs = []
    }

    function validForm() {
      var invalidForm = true

      invalidForm =
        !$scope.model.name ||
        (hasUsernameField() && $scope.form.username.$invalid) ||
        $scope.form.password.$invalid ||
        $scope.form.host.$invalid

      return (
        !invalidForm &&
        $scope.connectionStatus === INTEGRATION_CONNECTION_STATUS.VALID
      )
    }

    function hasUsernameField() {
      return jobOutcomePolicy.toUpperCase() !== INTEGRATION_TYPE.AGILE_CENTRAL
    }

    function getPasswordFieldName() {
      switch (jobOutcomePolicy.toUpperCase()) {
        case INTEGRATION_TYPE.JENKINS:
          return $translate.instant('title_apiKey')
        default:
          return $translate.instant('title_password')
      }
    }

    function getIntegrationLogo() {
      switch (jobOutcomePolicy.toUpperCase()) {
        case INTEGRATION_TYPE.JENKINS:
          return 'images/integrations/jenkins.png'
        default:
          return ''
      }
    }

    function getLogoClass() {
      switch (jobOutcomePolicy.toUpperCase()) {
        case INTEGRATION_TYPE.JENKINS:
          return 'jenkins'
        default:
          return ''
      }
    }

    function _updateCredentialsFields(credentials) {
      $scope.credentialsId = credentials.id
      $scope.model.name = credentials.name
      $scope.model.username = credentials.username
      $scope.model.host = credentials.host
      $scope.model.password = ''
    }

    function save() {
      JobOutcomePolicyService.openCredentialsEditConfirmModal().then(
        function () {
          JobOutcomePolicyService.updateCredentials(
            jobOutcomePolicy,
            $scope.model,
            $scope.credentialsId
          )
        }
      )
    }

    function cancelEdit() {
      $location.path(UserService.buildUrl('/settings/integration'), true)
    }

    init()
  }
})()
